class AdvancedSystemForm {
    constructor(formID, availableSystemGroups, systemID = null, services = null) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.fv = null;
        this.repeater = null;
        this.formID = formID;
        this.systemID = systemID;

        this.initServicesRepeater(services);
        this.initSystemGroupsTagify(availableSystemGroups);
        this.changeShortcutInApp();
    }
    fillFormWithSystemInfo(systemInfo, isDuplicate = true){
        let form = document.getElementById(this.formID);
        let jQueryForm = $(form);

        if(form) {
            // Icon + name + host
            if(systemInfo.iconID){
                form.querySelector('#add-system-icon').src = '/media/goodaccess/icons/system/' + systemInfo.iconID + '.svg';
                form.querySelector('input[name="iconID"]').value = systemInfo.iconID;
            }
            form.querySelector('input[name="name"]').value = (systemInfo.name ? (systemInfo.name + (isDuplicate ? ' - duplicate' : '')) : '');
            form.querySelector('input[name="host"]').value = (systemInfo.host ? systemInfo.host : '');
            form.querySelector('textarea[name="description"]').value = (systemInfo.description ? systemInfo.description : '');
            // Shortcut in app
            if (systemInfo.customUri) {
                form.querySelector('input[name="showSystemInApp"]').checked = true;
                form.querySelector('input[name="customUri"]').value = systemInfo.customUri;
            } else {
                form.querySelector('input[name="showSystemInApp"]').checked = (systemInfo.length === 0); // If the systemInfo is empty -> this is a new system creation and the checkbox must be checked
                form.querySelector('input[name="customUri"]').value = '';
            }
            // Groups
            const inputElm = form.querySelector('input[name=groups]');
            if (inputElm.__tagify) {
                inputElm.__tagify.removeAllTags();
                if (systemInfo.groupsArr && systemInfo.groupsArr.length > 0) {
                    inputElm.__tagify.addTags(systemInfo.groupsArr);
                }
            }
            // Access Cards
            let accessCards = [];
            if(systemInfo.accessCards){
                for (let accessCard of systemInfo.accessCards) {
                    accessCards.push(accessCard.uuid);
                }
            }
            jQueryForm.find('select[name="accessCard[]"]').val(accessCards).trigger('change');
            // Services
            let list = [];
            if(systemInfo.services){
                for(let service of systemInfo.services){
                    list.push({
                        'type': service.type,
                        'protocol': service.protocolTypeID,
                        'port': service.port
                    });
                }
            }
            this.repeater.setList(list);
            this.initFormValidation();
        }
}
    changeShortcutInApp(){
        let form = $('#'+this.formID);
        let showShortcutInApp = form.find('input[name=showSystemInApp]');

        showShortcutInApp.on('change', function () {
            let customUriContainer = form.find('.custom-uri-container');
            if(this.checked){
                customUriContainer.slideDown(200, 'linear');
            } else {
                customUriContainer.slideUp(200, 'linear');
            }
        });
    }
    /** Init tagify inputs for groups in system form */
    initSystemGroupsTagify(availableSystemGroups){
        let notice = $('#systemFormGroupNotice');
        /** In create system form  */
        const groupsInput = document.querySelector('#'+this.formID+' input[name=groups]');
        if(groupsInput){
            let tagify = new SystemGroupsTagify(groupsInput, availableSystemGroups);
            tagify.on('add', function(e){
                if(e.detail.data.accessCards && notice){
                    notice.removeClass('d-none');
                }
            }).on('remove', function(e){
                let values = e.detail.tagify.value;
                for(let i in values){
                    if(values[i].accessCards === true){
                        break;
                    }
                }
                notice.addClass('d-none');
            });
        }
    }
    initServicesRepeater(services = null){
        let thisClass = this;
        let form = $('#'+this.formID);
        
        if(form){
            this.repeater = form.find('#advance-systems-services').repeater({
                initEmpty: true,
                show: function () {
                    let inputs = thisClass.getRowInputs($(this));
                    thisClass.disableInputs(inputs);

                    inputs.type.select2({
                        minimumResultsForSearch: 0,
                    });
                    inputs.protocol.select2({
                        minimumResultsForSearch: -1,
                    });

                    $(this).slideDown();
                },
                hide: function (deleteElement) {
                    $(this).slideUp(deleteElement, function() {
                        $(this).remove();
                        thisClass.initFormValidation();
                    });
                },
            });

            // Set services in edit
            if(services){
                let list = [];
                for(let service of services){
                    list.push({
                        'type': service.type,
                        'protocol': service.protocolTypeID,
                        'port': service.port
                    });
                }
                this.repeater.setList(list);
                this.initFormValidation();
            } else {
                this.initFormValidation(false);
            }

            form.find('[data-repeater-create-button="true"]').on('click', function(e) {
                let addButton = form.find('[data-repeater-create]');
                addButton.trigger('click');

                let addedRow = form.find('[data-repeater-item]').last();
                let inputs = thisClass.getRowInputs(addedRow);

                let type = $(this)[0].attributes.type.value;
                let port = $(this)[0].attributes.port.value;
                let protocol = $(this)[0].attributes.protocol.value;

                inputs.type.val(type).trigger('change');
                inputs.protocol.val(protocol ? protocol : '1').trigger('change');
                inputs.port.val(port);

                inputs.type.select2({
                    minimumResultsForSearch: 0,
                });
                inputs.protocol.select2({
                    minimumResultsForSearch: -1,
                });

                thisClass.disableInputs(inputs);

                thisClass.initFormValidation();
            });

            this.hostChange(form);
            this.initSelectPreset();
            new DropdownMenuSearch(this.formID);
        }
    }
    hostChange(form){
        const thisClass = this;
        let customUriInput = form.find('input[name="customUri"]');
        form.find('input[name="host"]').on('change', function (e) {
            if($(this).val().includes('://')){
                customUriInput.val($(this).val());

                const type = $(this).val().split('://')[0].toUpperCase();
                let host = $(this).val().split('://')[1].replace(/\/$/, '').replace(/^www./, ''); // Get after ://, remove / from the end and www. from the beginning
                let port = host.split(':')[1];
                host = host.split(':')[0].split('/')[0];

                $(this).val(host);
                let addButton = form.find('[data-repeater-create-button="true"][type="'+type+'"]');
                if(addButton[0]){
                    let services = form.find('[data-repeater-item]');
                    if(services.length === 0){
                        // If the same ports exist - add a service with the input type
                        if(!port || addButton[0].attributes.port.value === port){
                            addButton.trigger('click');
                        } else {
                            // If not, add a custom service and fill in the port
                            form.find('[data-repeater-create-button="true"][type="Custom"]').trigger('click');
                            let addedRow = form.find('[data-repeater-item]').last();
                            let inputs = thisClass.getRowInputs(addedRow);
                            inputs.port.val(port);
                        }
                    }
                }
            } else if($(this).val()) {
                let host = $(this).val();
                $(this).val(host.split('/')[0]);
                customUriInput.val('https://'+host);
            }
            thisClass.fv.validateField('host');
        });
    }
    getRowInputs(thisRow){
        let inputWrappers = {
            port: thisRow.find('.fv-row[data-kt-repeater="port"]'),
            protocol: thisRow.find('.fv-row[data-kt-repeater="protocol"]'),
            type: thisRow.find('.fv-row[data-kt-repeater="type"]')
        }

        return {
            port: inputWrappers.port.find('input'),
            protocol: inputWrappers.protocol.find('select'),
            type: inputWrappers.type.find('select')
        };
    }
    disableInputs(inputs){
        let isNotCustomType = inputs.type.val() !== 'Custom';
        inputs.protocol.prop('disabled', isNotCustomType);
        inputs.port.prop('disabled', isNotCustomType);
    }
    setServiceByType(inputs){
        let selectedTypeOption = inputs.type.find(":selected")[0];
        const port = selectedTypeOption.attributes.port.value;
        const protocol = selectedTypeOption.attributes.protocol.value;
        inputs.port.val(port);
        inputs.protocol.val(protocol ? protocol : '1').trigger('change');
        return inputs;
    }
    initSelectPreset(){
        const thisClass = this;
        let preselect = $('#'+this.formID+' [data-repeater-preselect-button="true"]');
        if(preselect.length !== 0){
            preselect.on('click', function(e) {
                let services = $(this)[0].attributes.services.value;
                services = JSON.parse(services);
                let list = [];
                for(let service of services){
                    list.push({
                        'type': service.type,
                        'protocol': service.protocol,
                        'port': service.port
                    });
                }
                thisClass.repeater.setList(list);

                thisClass.initFormValidation();
            });
        }
    }
    initFormValidation(initServicesValidation = true){
        const thisClass = this;
        let form = document.getElementById(this.formID);

        const uniqueService = function () {
            return {
                validate: function (input) {
                    let valid = true;
                    let validatingRow = input.element.closest('[data-repeater-item]');
                    let validatingRowInputs = {
                        port: $(validatingRow).find('.fv-row[data-kt-repeater="port"] input'),
                        protocol: $(validatingRow).find('.fv-row[data-kt-repeater="protocol"] select'),
                    };
                    // Iterate through existing rows to check uniqueness
                    $("[data-repeater-item]:not([style*='display: none']) input[name^='services['][name$='][port]']").not("input[name='"+input.field+"']").each(function () {
                        let serviceRow = this.closest('[data-repeater-item]');
                        let serviceRowInputs = {
                            port: $(serviceRow).find('.fv-row[data-kt-repeater="port"] input'),
                            protocol: $(serviceRow).find('.fv-row[data-kt-repeater="protocol"] select')
                        };

                        if (validatingRowInputs.protocol.val() === serviceRowInputs.protocol.val() &&
                            validatingRowInputs.port.val() === serviceRowInputs.port.val()) {
                            valid = false;
                        }
                    });

                    return {
                        valid: valid
                    };
                }
            };
        };

        if(form){
            let submitButton = form.querySelector('button[type=submit]');
            let deleteButton = form.querySelector('#edit_system_form_delete');
            let icmpProtocolEl = form.querySelector('input[name="icmpProtocol"]');
            if(this.fv){
                this.fv.destroy();
            }

            this.fv = FormValidation.formValidation(form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Name cannot be over 45 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'description': {
                            validators: {
                                stringLength: {
                                    max: 256,
                                    message: 'Description cannot be over 45 characters',
                                },
                            }
                        },
                        'host': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 100,
                                    message: 'URL has to be between 3 and 110 characters long',
                                },
                                regexp: {
                                    regexp: /^([a-z.\-\d])+$|^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/,
                                    message: 'Colon and slash are not allowed characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/systems/?do=checkSystemValidation',
                                    data: function () {
                                        let returnArr = {
                                            organizationID: thisClass.organizationID
                                        };
                                        if(thisClass.systemID){
                                            returnArr.systemID = thisClass.systemID;
                                        }
                                        return returnArr;
                                    },
                                },
                            }
                        },
                        'customUri': {
                            validators: {
                                regexp: {
                                    regexp: /^((.)*:\/\/)?((www\.)?([a-zA-Z0-9\-_]+@)?((([a-zA-Z0-9\-_]+\.)+[a-zA-Z]{2,})|(\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b))(:[0-9]{1,5})?(\/[a-zA-Z0-9\-_\/\.\?\%\#\&\=]*)?)$/,
                                    message: 'Invalid format',
                                },
                                stringLength: {
                                    max: 110,
                                    message: 'Shortcut link/URI cannot be over 110 characters',
                                },
                                callback: {
                                    message: 'This field is required',
                                    callback: function(input) {
                                        const showSystemInApp = form.querySelector('[name="showSystemInApp"]');
                                        if(showSystemInApp.checked){
                                            return input.value.length !== 0;
                                        }
                                        return true;
                                    }
                                }
                            }
                        },
                        'noService': {
                            validators: {
                                callback: {
                                    message: 'Add at least one service',
                                    callback: function (input) {
                                        return form.querySelectorAll('[data-repeater-item]:not([style*="display: none"])').length !== 0;
                                    },
                                },
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: 0.5,
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check text-success',
                            invalid: 'fa fa-times text-danger',
                            validating: 'fa fa-refresh',
                            onPlaced: function (e) {
                                if (e.field === 'type') {
                                    e.iconElement.classList.add('d-none');
                                }
                            },
                        }),
                        message: new FormValidation.plugins.Message({
                            clazz: 'fv-plugins-message-container invalid-feedback',
                            container: function (field, ele) {
                                let pattern = /(services\[(\d+)]\[(type|protocol|port)])+/;
                                if(field.match(pattern)){
                                    return FormValidation.utils.closest(ele, '.service-row').nextElementSibling;
                                }
                                if(field === 'noService'){
                                    return form.querySelector('.no-service-message-box');
                                }
                                return FormValidation.utils.closest(ele, '.fv-row').nextElementSibling;
                            },
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.classList.contains('d-none') || e.element.classList.contains('form-select')){
                    // Get the icon plugin instance
                    const iconPlugin = thisClass.fv.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(e) {
                new DismissModal(thisClass.systemID ? 'edit_system_modal' : 'create_system_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
                let deleteServiceButtons = form.querySelectorAll('[data-repeater-delete]');
                deleteServiceButtons.forEach(deleteServiceButton => {
                    deleteServiceButton.disabled = true;
                });
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(e) {
                new DismissModal(thisClass.systemID ? 'edit_system_modal' : 'create_system_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
                let deleteServiceButtons = form.querySelectorAll('[data-repeater-delete]');
                deleteServiceButtons.forEach(deleteServiceButton => {
                    deleteServiceButton.disabled = false;
                });
            }).on('core.validator.validated', function (e) {
                if(icmpProtocolEl && e.field === 'host' && e.validator === 'remote'){
                    let icmpContainer = icmpProtocolEl.closest('#icmp-protocol-container');
                    if(icmpContainer){
                        if(e.result.meta.branchRange){
                            icmpContainer.classList.remove('d-none');
                        } else {
                            icmpContainer.classList.add('d-none');
                            icmpProtocolEl.checked = false;
                        }
                    }
                }
            }).registerValidator('uniqueService', uniqueService);

            if(initServicesValidation){
                thisClass.addValidationToServices();
            }
        }
    }
    addValidationToServices(){
        const thisClass = this;
        const typeValidator = {
                validators: {
                    notEmpty: {
                        message: 'This field is required'
                    }
                }
            },
            protocolValidator = {
                validators: {
                    notEmpty: {
                        message: 'This field is required'
                    },
                }
            },
            portValidator = {
                validators: {
                    notEmpty: {
                        message: 'This field is required'
                    },
                    stringLength: {
                        max: 11,
                        message: 'Port cannot be over 11 characters',
                    },
                    uniqueService: {
                        message: 'Each service must be unique'
                    },
                    callback: {
                        message: 'You have to type in valid port/range',
                        callback: function (input) {
                            /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                            if(input.value.includes('-')){
                                const splittedArr = input.value.split('-');
                                if(splittedArr.length <= 2){
                                    if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                        if(+splittedArr[0] < +splittedArr[1]){
                                            if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                return true;
                                            }
                                        }
                                    }
                                }
                            } else {
                                if(!isNaN(+input.value)){
                                    if(+input.value > 0 && +input.value <= 65535){
                                        return true;
                                    }
                                }
                            }
                            return false;
                        }
                    }
                }
            };

        let form = $('#'+this.formID);
        let services = form.find('[data-repeater-item]:not([style*="display: none"])');
        for(let service of services){
            if(this.fv){
                let inputs = this.getRowInputs($(service));
                this.fv.addField(inputs.type[0].attributes.name.value, typeValidator)
                    .addField(inputs.protocol[0].attributes.name.value, protocolValidator)
                    .addField(inputs.port[0].attributes.name.value, portValidator);

                inputs.type.unbind('change');
                inputs.protocol.unbind('change');
                inputs.port.unbind('change');
                inputs.type.select2({
                    minimumResultsForSearch: 0,
                });
                inputs.protocol.select2({
                    minimumResultsForSearch: -1,
                });
                inputs.type.on('change', function(e) {
                    thisClass.setServiceByType(inputs);
                    thisClass.disableInputs(inputs);
                    thisClass.revalidateAllField(services);
                });
                inputs.protocol.on('change', function(e) {
                    thisClass.revalidateAllField(services);
                });
                inputs.port.on('change', function(e) {
                    thisClass.revalidateAllField(services);
                });
            }
        }
    }
    revalidateAllField(services){
        for(let service of services) {
            if (this.fv) {
                let inputs = this.getRowInputs($(service));
                this.fv.validateField(inputs.type[0].attributes.name.value);
                this.fv.validateField(inputs.protocol[0].attributes.name.value);
                this.fv.validateField(inputs.port[0].attributes.name.value);
            }
        }
    }
}
window.AdvancedSystemForm = AdvancedSystemForm;